import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function LoadingScreen() {
  return (
    <div className="spinnerWrapper">
      <FontAwesomeIcon icon={['fas', 'spinner']} spin className="spinner" />
    </div>
  );
}
